import React from 'react';

import { PERSON_SIDEBAR } from 'constants/sidebarTypes';
import { SidebarLink } from 'components/common/tableComponents/cellTemplates';

const PersonSidebarLink = props => (
    <SidebarLink {...props} componentName={PERSON_SIDEBAR} />
);

export default PersonSidebarLink;
